import DateTime from "utils/DateTime";

const SECONDS_IN_MINUTE = 60;
const SECONDS_IN_HOUR = 3600;

export default class Timespan {
  constructor(startTime, endTime) {
    this.startTime = startTime;
    this.endTime = endTime;
  }

  static build(object) {
    return new Timespan(object.startDate, object.endDate);
  }

  static buildFromPlannedBreak({ referenceDate, plannedBreak }) {
    const start = DateTime.setHours(referenceDate, plannedBreak.startsAt);
    const end = DateTime.setHours(referenceDate, plannedBreak.endsAt);

    return new Timespan(start, end);
  }

  shrinkStartTo(time) {
    if (!time || time < this.startTime) {
      return this;
    }
    if (this.startTime <= time && time <= this.endTime) {
      return new Timespan(time, this.endTime);
    }
    return new Timespan(this.endTime, this.endTime);
  }

  shrinkEndTo(time) {
    if (!time || this.endTime < time) {
      return this;
    }
    if (this.startTime <= time && time <= this.endTime) {
      return new Timespan(this.startTime, time);
    }
    return new Timespan(this.startTime, this.startTime);
  }

  durationInHours() {
    return this.durationInSeconds() / SECONDS_IN_HOUR;
  }

  durationInMinutes() {
    return this.durationInSeconds() / SECONDS_IN_MINUTE;
  }

  durationInSeconds() {
    return DateTime.duration(this.startTime, this.endTime);
  }

  durationInMilliseconds() {
    return this.endTime - this.startTime;
  }

  include(time) {
    return this.startTime <= time && time < this.endTime;
  }

  isIntersecting(other) {
    return this.startTime < other.endTime && other.startTime < this.endTime;
  }

  intersection(other) {
    if (!this.isIntersecting(other)) return null;

    return new Timespan(
      new Date(Math.max(this.startTime, other.startTime)),
      new Date(Math.min(this.endTime, other.endTime)),
    );
  }

  splitByDay() {
    const firstDay = DateTime.startOfDay(this.startTime).toDate();
    const lastDay = DateTime.startOfDay(this.endTime).toDate();

    const days = [];
    if (firstDay.getTime() === lastDay.getTime()) {
      days.push(this);

      return days;
    }

    days.push(new Timespan(this.startTime, DateTime.setHours(this.startTime, "24:00")));

    let currentDay = DateTime.addDurationDate(firstDay, 1, "day");
    while (currentDay < lastDay) {
      days.push(new Timespan(DateTime.startOfDay(currentDay).toDate(), DateTime.setHours(currentDay, "24:00")));
      currentDay = DateTime.addDurationDate(currentDay, 1, "day");
    }

    days.push(new Timespan(DateTime.startOfDay(this.endTime).toDate(), this.endTime));

    return days;
  }
}
